import { FormEvent, useRef, useState } from "react";
import ButtonSubmit from "../../../../parts/ButtonSubmit";
import ErrorMessage from "../../../../parts/ErrorMessage";
import InputText from "../../../../parts/InputText";
import RequiredMark from "../../../../parts/RequiredMark";
import InputRef from "../../../../../interfaces/InputRef";
import { useAuth } from "../../../../../auth/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { ReserveScoutCensusSummaryForm } from "./ReserveScoutCensusSummaryForm";
import { Census } from "../../../../../model/census";

interface ReserveScoutCensusProps {
    census: Census | undefined;
}

function ReserveScoutCensus(props: ReserveScoutCensusProps) {
    const navigate = useNavigate();
    const { user } = useAuth();
    const loc = useLocation();
    const data: ReserveScoutCensusSummaryForm | null = loc.state?.data ?? fillFromCneus(props.census);

    const commentRef = useRef<InputRef>();

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();

        if (
            commentRef.current?.validate()
        ) {
            const data = new ReserveScoutCensusSummaryForm({
                comment: commentRef.current?.value() ?? '',
            })
            navigate("/scout-census/summary/reserve", { state: { data: data } });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <InputText
                ref={commentRef}
                label={'Uwagi'}
                placeholderText={'miejsce na twoje dodatkowe uwagi'}
                isRequired={false}
                rows={3}
                maxLength={500}
                initValue={data?.comment ?? ""} 
            />
            <RequiredMark withDescription />
            <ButtonSubmit text="Wyślij prośbę o rezerwę" />
        </form>
    );
}

export default ReserveScoutCensus;

function fillFromCneus(census: Census | undefined): ReserveScoutCensusSummaryForm | null {
    if(!census)
        return null;

    return new ReserveScoutCensusSummaryForm({
        comment: census.RegistrantComment,
    })
}
